// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "order_card-Uhq6d";
var _5 = "persons-cHFYj";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "order_card", _5 as "persons" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "order_card": _4, "persons": _5 }
